export enum BillState {
    Submit = 'Submit',
    Draft = 'Draft'
}